import axios from 'axios';

export const getList = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.post(`${process.env.REACT_APP_API}/product-preset/list`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const create = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.post(`${process.env.REACT_APP_API}/product-preset`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const getInformation = (token, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/product-preset/${id}`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const update = (token, payload, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.patch(`${process.env.REACT_APP_API}/product-preset/${id}`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}


export const remove = (token, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.delete(`${process.env.REACT_APP_API}/product-preset/${id}`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const removeAll = (token, customerId) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.delete(`${process.env.REACT_APP_API}/product-batch-preset/${customerId}`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const removeWishlistItem = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.delete(`${process.env.REACT_APP_API}/wishlist`, { headers, data: payload })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const getWishlist = (token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.get(`${process.env.REACT_APP_API}/wishlist`, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}

export const batchCreate = (token, payload) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    return axios.post(`${process.env.REACT_APP_API}/product-batch-preset`, payload, { headers })
    .then(function(response) {
        return response.data;
    })
    .catch(error => {
        if (error.response.status === 401)  {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (error.response.status === 404) {
            return window.location.href = '/404';
        }

        return error.response;
    });
}
